export const blockIconsBusinessandpaymentsPrecisionManufacturingNew = (
	<span className='material-symbols-outlined'>precision_manufacturing</span>
);
